var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.66602 2.66675V6.00008H3.05369M13.2914 7.33341C12.9634 4.70254 10.7191 2.66675 7.99935 2.66675C5.7611 2.66675 3.84488 4.04553 3.05369 6.00008M3.05369 6.00008H5.99935M13.3327 13.3334V10.0001H12.945M12.945 10.0001C12.1538 11.9546 10.2376 13.3334 7.99935 13.3334C5.2796 13.3334 3.03534 11.2976 2.70728 8.66675M12.945 10.0001H9.99935",
    stroke: "#818586",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/Update.8a6861e3a26c90e0ac956fee4e6f2082.svg";
export { ForwardRef as ReactComponent };